import { ECurrency } from '@/modules/currenciesModule/constants/currencies'

export const formatPrice = (
	number: number | string | undefined,
	fractionDigits = 2,
	returnOnlyNumberWithCurrency = false,
	bypassCurrency?: ECurrency,
) => {
	if (!number && number !== 0 && number !== '0') return number
	const currencyCookie = useCookie('currency')
	let currency = (currencyCookie?.value as ECurrency) || ECurrency.PLN
	if (bypassCurrency) {
		currency = bypassCurrency
	}
	const exchangeRate = Number(useCookie('currency-exchange-rate')?.value ?? 1)
	const currencyObj = CurrenciesMap[currency]
	const currencyInFront = currencyObj?.position === ECurrencySymbolPosition.FRONT ? CurrenciesMap[currency].symbol : ''
	const currencyInBack = currencyObj?.position === ECurrencySymbolPosition.BACK ? CurrenciesMap[currency].symbol : ''
	const multiplier = returnOnlyNumberWithCurrency ? 1 : exchangeRate
	if (typeof number === 'number') {
		const converted = new Intl.NumberFormat('pl-PL', {
			minimumFractionDigits: fractionDigits,
			maximumFractionDigits: fractionDigits,
		}).format(number * multiplier)
		return `${currencyInFront}${converted} ${currencyInBack}`
	} else {
		const parsedNumber = parseFloat(number.replace(/,/g, ''))
		if (!isNaN(parsedNumber)) {
			const converted = new Intl.NumberFormat('pl-PL', {
				minimumFractionDigits: fractionDigits,
				maximumFractionDigits: fractionDigits,
			}).format(parsedNumber * multiplier)
			return `${currencyInFront}${converted} ${currencyInBack}`
		} else {
			return number
		}
	}
}

export const formatPriceInReservationCurrency = (
	number: number | string | undefined,
	fractionDigits = 2,
	currency = ECurrency.PLN,
	newExchangeRate?: number,
) => {
	if (!number && number !== 0 && number !== '0') return number
	const exchangeRate = newExchangeRate || Number(useCookie('currency-exchange-rate')?.value ?? 1)
	const currencyObj = CurrenciesMap[currency]
	const currencyInFront = currencyObj?.position === ECurrencySymbolPosition.FRONT ? CurrenciesMap[currency].symbol : ''
	const currencyInBack = currencyObj?.position === ECurrencySymbolPosition.BACK ? CurrenciesMap[currency].symbol : ''
	if (typeof number === 'number') {
		const converted = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: fractionDigits,
			maximumFractionDigits: fractionDigits,
		}).format(number / exchangeRate)
		return `${currencyInFront}${converted} ${currencyInBack}`
	} else {
		const parsedNumber = parseFloat(number.replace(/,/g, ''))
		if (!isNaN(parsedNumber)) {
			const converted = new Intl.NumberFormat('en-US', {
				minimumFractionDigits: fractionDigits,
				maximumFractionDigits: fractionDigits,
			}).format(parsedNumber / exchangeRate)
			return `${currencyInFront}${converted} ${currencyInBack}`
		} else {
			return number
		}
	}
}
